import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
// redux
import { updateUserById } from 'redux/users/operations';
// scss
import 'components/Form/Input.scss';
import './UserEditForm.scss';

const UserEditPswForm = ({ data, closeModal }) => {
  const [showPassword, setShowPassword] = useState(false);
  const { user_id } = data ?? {};
  const dispatch = useDispatch();

  function onSubmit(e) {
    e.preventDefault();
    if (!user_id) return

    const form = e.currentTarget;
    const data = { password: form?.elements?.password?.value, };

    dispatch(updateUserById({ id: user_id, data }));
    closeModal();
  }

  return (
    <>
      <form
        className="user-form"
        id="userEditPswForm"
        name="userForm"
        onSubmit={onSubmit}
      >
        <label className="auth-form__label label">
          <span>Новий пароль</span>
          <input
            className="input auth-form__input"
            type={showPassword ? "text" : "password"}
            placeholder="Введіть новий пароль"
            name="password"
            required
            minLength={6}
            autoComplete="off"
          />
          <button className="password__btn-show" type="button" onClick={() => setShowPassword(!showPassword)}>
            {showPassword ? (
              <svg className="icon--eye-blocked" version="1.1" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" >
                <title>eye-blocked</title>
                <path d="M29.561 0.439c-0.586-0.586-1.535-0.586-2.121 0l-6.318 6.318c-1.623-0.492-3.342-0.757-5.122-0.757-6.979 0-13.028 4.064-16 10 1.285 2.566 3.145 4.782 5.407 6.472l-4.968 4.968c-0.586 0.586-0.586 1.535 0 2.121 0.293 0.293 0.677 0.439 1.061 0.439s0.768-0.146 1.061-0.439l27-27c0.586-0.586 0.586-1.536 0-2.121zM13 10c1.32 0 2.44 0.853 2.841 2.037l-3.804 3.804c-1.184-0.401-2.037-1.521-2.037-2.841 0-1.657 1.343-3 3-3zM3.441 16c1.197-1.891 2.79-3.498 4.67-4.697 0.122-0.078 0.246-0.154 0.371-0.228-0.311 0.854-0.482 1.776-0.482 2.737 0 1.715 0.54 3.304 1.459 4.607l-1.904 1.904c-1.639-1.151-3.038-2.621-4.114-4.323z"> </path>
                <path d="M24 13.813c0-0.849-0.133-1.667-0.378-2.434l-10.056 10.056c0.768 0.245 1.586 0.378 2.435 0.378 4.418 0 8-3.582 8-8z"> </path>
                <path d="M25.938 9.062l-2.168 2.168c0.040 0.025 0.079 0.049 0.118 0.074 1.88 1.199 3.473 2.805 4.67 4.697-1.197 1.891-2.79 3.498-4.67 4.697-2.362 1.507-5.090 2.303-7.889 2.303-1.208 0-2.403-0.149-3.561-0.439l-2.403 2.403c1.866 0.671 3.873 1.036 5.964 1.036 6.978 0 13.027-4.064 16-10-1.407-2.81-3.504-5.2-6.062-6.938z"> </path>
              </svg>
            ) : (
              <svg className="icon--eye" version="1.1" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" >
                <title>eye</title>
                <path d="M16 6c-6.979 0-13.028 4.064-16 10 2.972 5.936 9.021 10 16 10s13.027-4.064 16-10c-2.972-5.936-9.021-10-16-10zM23.889 11.303c1.88 1.199 3.473 2.805 4.67 4.697-1.197 1.891-2.79 3.498-4.67 4.697-2.362 1.507-5.090 2.303-7.889 2.303s-5.527-0.796-7.889-2.303c-1.88-1.199-3.473-2.805-4.67-4.697 1.197-1.891 2.79-3.498 4.67-4.697 0.122-0.078 0.246-0.154 0.371-0.228-0.311 0.854-0.482 1.776-0.482 2.737 0 4.418 3.582 8 8 8s8-3.582 8-8c0-0.962-0.17-1.883-0.482-2.737 0.124 0.074 0.248 0.15 0.371 0.228v0zM16 13c0 1.657-1.343 3-3 3s-3-1.343-3-3 1.343-3 3-3 3 1.343 3 3z"></path>
              </svg>
            )}
          </button>
        </label>
        <div className="passenger-form__btn-wrap">
          <button type="submit" className="passenger-form__btn passenger-form__btn--submit" > Зберегти </button>
          <button type="button" className="passenger-form__btn passenger-form__btn--cancel" onClick={() => closeModal()} >
            <svg xmlns="http://www.w3.org/2000/svg" width="8" height="12" viewBox="0 0 8 12" fill="none" >
              <path d="M6.51855 1L1.51855 6L6.51855 11" stroke="#B79A5D" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
            Назад
          </button>
        </div>
      </form>
    </>
  );
};

export default UserEditPswForm;
